/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { Container } from './styles';

interface BannerRadarProps {
  show?: boolean;
  onClose?: () => void;
}

const BannerRadarModal = ({ show, onClose }: BannerRadarProps) => {
  const [internalShow, setInternalShow] = useState(false);

  useEffect(() => {
    if (!hasCookie('ModalRadar')) {
      setInternalShow(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('ModalRadar', true);
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal size="lg" show={shouldShow} onHide={handleClose}>
      <Container>
        <div className="modal-body modal-bond">
          <button aria-label="Close" className="close" onClick={handleClose} type="button">
            <span aria-hidden="true">×</span>
          </button>
          <div className="row">
            <div className="col-12 col-md-5 px-4 py-2 mt-5">
              <span className="badge badge-new text-uppercase mb-3">
                Alerta de novidade por aqui!
              </span>
              <p>
                Agora ficou ainda mais fácil encontrar licitações: você pode fazer a busca pelo{' '}
                <strong className="text-green">Raio de Atuação!</strong>.
              </p>
              <p>
                É simples: Escolha essa opção, informe o endereço e defina a distância em
                quilômetros.
              </p>
              <p>
                Se preferir, ainda da para filtrar por <strong>Estado</strong> e{' '}
                <strong>Cidade</strong> ou <strong>Região.</strong>
              </p>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default BannerRadarModal;
